export default __webpack_public_path__ + "images/acc4dad6bd8e1dde1e6aaaed82db7d2a.svg";